<script>
import { CustomMenu } from '@/api'
import MenuForm from './MenuForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [MenuForm],
  data() {
    return {
      redirectRoute: { name: 'Custom Menu List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Input({
          label: 'Nazwa robocza',
          modelPath: [this, 'form', 'name']
        }),
        ...this.getBaseFields()
      ]
    }
  },
  computed: {
    service() {
      return CustomMenu
    }
  }
}
</script>
